import useCheckRole from "Hooks/APICheckRole";
import { useVoiceRegion } from "Hooks/Endpoints";
import React, { Fragment, useState } from "react";
import {
  Breadcrumb,
  Button,
  Confirm,
  Container,
  Menu,
} from "semantic-ui-react";
import OutboundProxyView from "./OutboundProxyView";
import OutboundRouteView from "./OutboundRouteView";
import RegionForm from "./RegionForm";
import VoiceServerView from "./VoiceServerView";

const VoiceRegionDetail = () => {
  const { hasRole, roles } = useCheckRole();
  const { voiceRegion, unselect, remove } = useVoiceRegion();
  const [activeView, setActiveView] = useState<string>("edit");
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);

  return (
    <Container fluid>
      <Fragment>
        <Menu>
          <Menu.Item header>Configuration</Menu.Item>
          <Menu.Item>
            <Breadcrumb>
              <Breadcrumb.Section link onClick={() => unselect()}>
                Regions
              </Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section>{voiceRegion.name}</Breadcrumb.Section>
            </Breadcrumb>
          </Menu.Item>
          <Menu.Menu position='right'>
            {hasRole(roles.config.region.roles.delete) && (
              <Menu.Item>
                <Button
                  size='tiny'
                  color='red'
                  onClick={() => setConfirmDelete(true)}
                >
                  Delete
                </Button>
              </Menu.Item>
            )}
          </Menu.Menu>
        </Menu>

        <Menu>
          <Menu.Item
            active={activeView === "edit"}
            onClick={() => setActiveView("edit")}
          >
            Edit
          </Menu.Item>
          <Menu.Item
            active={activeView === "proxies"}
            onClick={() => setActiveView("proxies")}
          >
            Proxies
          </Menu.Item>
          <Menu.Item
            active={activeView === "routes"}
            onClick={() => setActiveView("routes")}
          >
            Routes
          </Menu.Item>
          <Menu.Item
            active={activeView === "servers"}
            onClick={() => setActiveView("servers")}
          >
            Servers
          </Menu.Item>
        </Menu>

        <div style={{ padding: "10px" }}>
          {activeView === "edit" && <RegionForm />}
          {activeView === "proxies" && <OutboundProxyView />}
          {activeView === "routes" && <OutboundRouteView />}
          {activeView === "servers" && <VoiceServerView />}
        </div>
      </Fragment>

      <Confirm
        open={confirmDelete}
        onCancel={() => setConfirmDelete(false)}
        onConfirm={() => remove(voiceRegion.id)}
      />
    </Container>
  );
};

export default VoiceRegionDetail;
